<template>
    <div class="login-wrap" v-bind:style="{ backgroundImage: backgroundImageUrl }">
        <!--    <img-->
        <!--      src="../../assets/img/title.png"-->
        <!--      alt=""-->
        <!--      class="login-wrap-title"-->
        <!--    >-->
        <div class="ms-login">
            <div class="ms-title">{{ titleStr }}代驾管理后台</div>
            <!-- <div class="ms-title" v-if="source === 'pinganshun'">平安代驾管理后台</div>
            <div v-else class="ms-title">耿师傅v3代驾管理后台</div> -->

            <el-form :model="formData" label-width="0px" class="ms-content">
                <el-row type="flex" style="margin: 10px 0">
                    <el-input
                        type="text"
                        v-model="formData.user_name"
                        :placeholder="formRules.user_name.placeholder"
                        :value="formData.user_name"
                        class="login-input"
                        prefix-icon="el-icon-user"
                        @keyup.enter.native="submitForm"
                    >
                    </el-input>
                </el-row>

                <el-row type="flex" style="margin: 10px 0">
                    <el-input
                        type="password"
                        v-model="formData.password"
                        :placeholder="formRules.password.placeholder"
                        :value="formData.password"
                        class="login-input"
                        prefix-icon="el-icon-goods"
                        @keyup.enter.native="submitForm"
                    >
                    </el-input>
                </el-row>

                <el-row type="flex" style="margin: 10px 0">
                    <el-input
                        type="password"
                        v-model="formData.google_code"
                        :placeholder="formRules.google_code.placeholder"
                        :value="formData.google_code"
                        class="login-input"
                        prefix-icon="el-icon-paperclip"
                        maxlength="6"
                        @keyup.enter.native="submitForm"
                    >
                    </el-input>
                </el-row>

                <el-row type="flex" style="margin: 10px 0" v-if="source == 'gengshifu'">
                    <div class="city-select">
                        <el-select
                            v-model="city_tag"
                            placeholder="请选择城市"
                            style="width: 180px"
                            @visible-change="cityVisible"
                            @change="cityChange"
                            :disabled="!(source == 'gengshifu')"
                        >
                            <el-option-group
                                v-for="group in city_data"
                                :key="group.label"
                                v-if="group[0].alias != '主库'"
                                :label="group[0].alias"
                            >
                                <el-option v-for="item in group" :key="item.city_tag" :label="item.include" :value="item.city_tag">
                                </el-option>
                            </el-option-group>
                        </el-select>
                    </div>
                </el-row>
                <!-- <el-row type="flex" style="margin: 10px 0">
                    <div class="city-select" v-if="source === 'pinganshun'">
                        <el-select v-model="city_tag" placeholder="请选择城市" style="width: 180px" @change="cityChangeQita">
                            <el-option label="临沂" value="LINYISHI"></el-option>
                        </el-select>
                    </div>
                    <div class="city-select" v-else>
                        <el-select
                            v-model="city_tag"
                            placeholder="请选择城市"
                            style="width: 180px"
                            @visible-change="cityVisible"
                            @change="cityChange"
                        >
                            <el-option-group
                                v-for="group in city_data"
                                :key="group.label"
                                v-if="group[0].alias != '主库'"
                                :label="group[0].alias"
                            >
                                <el-option v-for="item in group" :key="item.city_tag" :label="item.include" :value="item.city_tag">
                                </el-option>
                            </el-option-group>
                        </el-select>
                    </div>
                </el-row> -->

                <div style="margin: 10px 0; display: flex">
                    <el-input
                        type="text"
                        id="code"
                        v-model="code"
                        placeholder="请输入验证码"
                        :value="formData.google_code"
                        style="width: 180px"
                        class="login-input"
                        prefix-icon="el-icon-magic-stick"
                        @keyup.enter.native="submitForm"
                    >
                    </el-input>
                    <!--验证码组件-->
                    <s-identify :identifyCode="identifyCode" @re="re"></s-identify>
                </div>

                <!-- <div class="login-btn">
                    <el-button type="primary" @click="submitForm">登录 </el-button>
                </div> -->

                <div :class="{ 'login-btn-xiaolin': xiaolinStr == 'HAIKOU' }" class="login-btn">
                    <el-button type="primary" @click="submitForm">登录 </el-button>
                </div>
            </el-form>
        </div>
        <!-- 谷歌验证模态框 -->
        <el-dialog
            title="使用谷歌验证器扫描绑定"
            :visible.sync="param.gooleDegModel"
            width="300px"
            :before-close="handleClose"
            center
            style="text-align: center"
        >
            <img :src="param.pictureCode" alt="谷歌验证二维码" id="pictureCode" />
            <div class="text">
                <p>点击下方文字下载谷歌验证器</p>
                <div style="display: flex; justify-content: center; margin-top: 20px">
                    <el-button type="text" @click="param.Android_download = true">安卓版 </el-button>
                    <span style="display: inline-block; width: 1px; height: 20px; background-color: #ccc; margin: 5px 10px 0"></span>
                    <el-button type="text" @click="param.ios_download = true">ios版 </el-button>
                </div>
            </div>
            <!-- 谷歌验证器秘钥 -->
            <el-input type="text" v-model="param.googleKey" placeholder="谷歌验证器秘钥" @keyup.enter.native="googleKey()"> </el-input>
            <el-button @click="googleKey()" type="primary" class="btn">进行验证 </el-button>
        </el-dialog>

        <el-dialog
            title="扫描二维码下载安卓版谷歌验证器"
            :visible.sync="param.Android_download"
            width="800px"
            center
            style="text-align: center"
            class="android-download"
        >
            <p style="text-align: center">谷歌秘钥：{{ google_secret }}</p>
            <img src="../../assets/Android.png" alt="" style="display: block; margin: 0 auto" />
        </el-dialog>

        <el-dialog
            title="扫描二维码下载ios版谷歌验证器"
            :visible.sync="param.ios_download"
            width="800px"
            center
            style="text-align: center"
            class="ios-download"
        >
            <p style="text-align: center">谷歌秘钥：{{ google_secret }}</p>
            <img src="../../assets/ios.png" alt="" style="display: block; margin: 0 auto" />
        </el-dialog>
    </div>
</template>

<script>
var _this;
import axios from 'axios'; // AJAX封装类
import { config } from '../../utils/config'; //配置
import SIdentify from '../common/sidentify';
import bus from '../common/bus';

export default {
    components: {
        SIdentify
    },
    created() {
        _this = this;

        localStorage.removeItem('access_token');
        sessionStorage.removeItem('navBar');

        _this.refreshCode();
        _this.cityVisible();
    },
    mounted() {
        this.identifyCode = '';
        this.makeCode(this.identifyCodes, 4);

        //  let queryStr = this.$router;

        let locationHref = location.href; //获取url地址

        let codeStr = 'source=';

        let locationIndex = locationHref.indexOf(codeStr); //获取source=的索引，如果该值大于0 代表URL中存在拼接的参数，则把拼接的参数存到source中
        if (locationIndex > 0) {
            localStorage.setItem('source', locationHref.slice(locationIndex + codeStr.length));
        } else {
            //如果url中不存在拼接的参数，则source存'gengshifu'
            localStorage.setItem('source', 'gengshifu');
        }

        _this
            .$post('/conf/getRenameConfLists')
            .then((res) => {
                console.log('获取完信息');
                for (let i = 0; i < res.data.length; i++) {
                    // 如果是小林代驾改变背景图片,因为Vue的数据绑定和虚拟DOM机制会使得直接操作DOM成为不推荐的做法。
                    // 但是，你可以通过Vue的响应式数据和指令系统来实现类似的功能。
                    // if(res.data[i].name=='HAIKOU'){
                    //     let xiaoLin = document.getElementsByClassName('login-wrap')[0]; // 数组类型，要加[0]

                    //     xiaoLin.style.backgroundImage = `url(${require('../../assets/img/xiaolin.png')})`;

                    // }

                    //遍历接口返回的数组，如果缓存中的source等于接口返回数组对象中的source,则把该对象存在缓存中
        

                    if (res.data[i].source == localStorage.getItem('source')) {
                        localStorage.setItem('cityInfo', JSON.stringify(res.data[i]));
                  
                        // 如果是小林代驾改变背景图片
                        if (res.data[i].city_tag == 'HAIKOU') {
                            _this.backgroundImageUrl = `url(${require('../../assets/img/xiaolin.png')})`;

                            _this.xiaolinStr = res.data[i].city_tag;
                        } else {
                            _this.backgroundImageUrl = `url(${require('../../assets/img/new.png')})`;
                        }
                        break;
                    } else {
                        localStorage.setItem(
                            'cityInfo',
                            JSON.stringify({
                                city_code: '',
                                city_tag: '',
                                name: '耿师傅',
                                source: 'gengshifu',
                                title_logo_url: 'favicon.ico'
                            })
                        );
                        _this.backgroundImageUrl = `url(${require('../../assets/img/new.png')})`;
               
                    }
                }

                _this.titleStr = JSON.parse(localStorage.getItem('cityInfo')).name;
                _this.xiaolinStr = JSON.parse(localStorage.getItem('cityInfo')).city_tag;

                _this.source = localStorage.getItem('source');
                _this.formData.source = localStorage.getItem('source');

                if (_this.titleStr == '耿师傅') {
                    _this.city_tag = '';
                    localStorage.setItem('city_tag', _this.city_tag);
                } else {
                    _this.city_tag = JSON.parse(localStorage.getItem('cityInfo')).city_tag;

                    localStorage.setItem('city_tag', _this.city_tag);
                }
                console.log('bus');
                bus.$emit('upDataCityInfo', localStorage.getItem('cityInfo'));
            })
            .catch((err) => {});
    },

    data: function () {
        return {
            xiaolinStr: '',

            backgroundImageUrl: '',
            userData: JSON.parse(localStorage.getItem('login')),
            cityInfo: JSON.parse(localStorage.getItem('cityInfo')),

            titleStr: '',
            labelName: '',

            source: '',

            //城市数据
            city_data: [],
            city_tag: '',

            google_secret: '',
            formData: {
                user_name: '',
                password: '',
                google_code: '',
                source: ''
                // user_name: '',
                // password: '',
                // google_code: ''
            },
            identifyCodes: '1234567890',
            identifyCode: '',
            code: '', //text框输入的验证码
            formRules: {
                user_name: {
                    placeholder: '用户名',
                    rules: {
                        required: true,
                        message: '用户名必须为8-20位',
                        regulation: 'between_str',
                        rulesData: [8, 20]
                    }
                },
                password: {
                    placeholder: '密码',
                    rules: {
                        required: true,
                        message: '密码必须为8-20位',
                        regulation: 'between_str',
                        rulesData: [8, 20]
                    }
                },
                google_code: {
                    placeholder: '谷歌验证码',
                    rules: {
                        required: true,
                        message: '谷歌验证码为6位数字',
                        regulation: 'eq_num',
                        rulesData: 6
                    }
                }
            },

            param: {
                gooleDegModel: false,
                pictureCode: '',
                googleKey: '',
                Android_download: false,
                ios_download: false
            }
        };
    },
    methods: {
        cityVisible() {
            if (_this.city_data.length == 0) {
                // 删除city_tag
                localStorage.removeItem('city_tag');
                _this.$nextTick(function () {
                    axios.defaults.baseURL = config.axios_normalURL; //请求base url

                    _this
                        .$post('/city/getCityLists')
                        .then((res) => {
                            _this.city_data = res.data;

                            axios.defaults.baseURL = config.axios_baseURL; //请求base url
                        })
                        .catch((err) => {});
                    axios.defaults.baseURL = config.axios_baseURL; //请求base url
                });
            }
        },
        // 城市选中事件
        cityChange(val) {
            // 设置city_tag
            localStorage.setItem('city_tag', val);
        },

        //验证码
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },

        refreshCode() {
            this.identifyCode = '';
            this.makeCode(this.identifyCodes, 4);
        },
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
            }
        },
        re(msg) {
            this.identifyCode = msg;
        },

        // 登录
        submitForm() {
            // this.$btts({
            //     tex: '有新订单需要协助指派',
            //     tok: localStorage.getItem('bdToken'),
            //
            // }, {
            //     volume: 0.3,
            //     autoDestory: true,
            //     timeout: 10000,
            //     hidden: false,
            //     onInit: function (htmlAudioElement) {
            //
            //     },
            //     onSuccess: function(htmlAudioElement) {
            //         htmlAudioElement.className = 'baidu'
            //         htmlAudioElement.play()
            //
            //     },
            //     onError: function(text) {
            //
            //     },
            //     onTimeout: function () {
            //
            //     }
            // });
            // return;

            localStorage.setItem(config.localStorage_token_name, '');
            // 判断验证码
            if (this.code == '') {
                _this.$message.error('请输入验证码');
                return;
            }
            if (this.identifyCode !== this.code) {
                this.code = '';
                this.refreshCode();
                _this.$message.error('请驶入正确的验证码');
                return;
            }

            if (this.city_tag == '') {
                _this.$message.error('请选择城市');
                return;
            }

            _this
                .$post('/welcome/loginsubmit', _this.formData, _this.formRules)
                .then((res) => {
                    if (res.code === 200) {
                        //弹出显示成功
                        this.$message.success(res.msg);
                        //设置缓存
                        localStorage.setItem(config.localStorage_token_name, res.data.access_token);

                        bus.$emit('logIn');

                        // 获取登录信息
                        _this
                            .$post('/mine/tokenDetails')
                            .then((res) => {
                                // 缓存登录信息
                                localStorage.setItem('login', JSON.stringify(res.data));

                                // 跳转路由至首页
                                _this.$router.push({
                                    path: '/dashboard'
                                });
                            })
                            .catch((err) => {});
                    } else if (res.data.code === 888) {
                        //谷歌验证模态框显示
                        _this.param.gooleDegModel = true;

                        _this.google_secret = res.data.data.google_secret;

                        _this.param.pictureCode = res.data.data.google_qrcode_url;
                    }
                })
                .catch((err) => {});
        },
        // 对话框关闭
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },

        // 谷歌秘钥验证
        googleKey() {
            _this
                .$post('/welcome/googleStatus', {
                    user_name: _this.formData.user_name,
                    google_code: _this.param.googleKey
                })
                .then((res) => {
                    // 弹出提示框
                    if (res.code === 200) {
                        //弹出提示框
                        _this.$message(res.msg);
                        // 关闭对话框
                        _this.param.gooleDegModel = false;
                    }
                })
                .catch((err) => {});
        }
    }
};
</script>

<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100vh;
    /* background-image: url(../../assets/img/new.png); */
    background-size: 100% 100%;
}

.login-wrap-title {
    position: absolute;
    bottom: 15%;
    right: 150px;
}

.ms-title {
    width: 100%;
    line-height: 30px;
    font-size: 22px;
    font-weight: 800;
    /*padding: 10px 0;*/
    padding-bottom: 10px;
    text-align: center;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin: 20px 0;
}

.ms-login {
    position: absolute;
    border-radius: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(255, 255, 255, 1);
    padding: 40px !important;
    overflow: hidden;
}

.ms-content {
    padding: 20px;
}

.login-btn {
    text-align: center;
    margin-top: 30px;
}

.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}

#pictureCode {
    display: block;
    margin: 0 auto;
    width: 200px;
    height: 200px;
}

.text {
    width: 100%;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
}

.text p {
    width: 100%;
    text-align: center;
}

.btn {
    display: block;
    margin: 20px auto;
}

.login-btn .el-button.el-button--primary.el-button--small {
    background-color: #c5812c;
    border: 0;
}

/* 小琳代驾登录按钮样式 */
.login-btn-xiaolin .el-button.el-button--primary.el-button--small {
    background-color: #1ba1ff;
    border: 0;
}

.login-span {
    font-size: 12px;
    color: #ccc;
    display: inline-block;
    min-width: 70px;
    height: 32px;
    line-height: 32px;
    text-align: right;
    padding-right: 5px;
    box-sizing: border-box;
}
</style>
